export const COLORS = {
  PRIMARY: '#3e8bff',

  DARK_BORDER: '#2d343e',
  MAIN_GRAY: '#6E767F',
  DARK_GRAY: '#212933',
};
